import ResourcesDispatcher from "../config/ResourcesDispatcher";
export default class RightSideGridAnimations {
    constructor(pathName) {
        this.rightSideGridAnimation = layoutBuilder.findByPath(`${pathName}`);
    }
    setVisible(value) {
        this.rightSideGridAnimation.setVisible(value);
    }
    playWin(name) {
        return new Promise((resolve) => {
            const entry = this.rightSideGridAnimation.animationState.setAnimation(0, name, false);
            entry.listener = {
                complete: () => {
                    entry.listener = null;
                    resolve(true);
                }
            };
        });
    }
    playIdle(name) {
        this.rightSideGridAnimation.animationState.setAnimation(0, name, true);
    }
    playEnter(name) {
        return new Promise((resolve) => {
            const entry = this.rightSideGridAnimation.animationState.setAnimation(0, name, false);
            entry.listener = {
                complete: () => {
                    entry.listener = null;
                    resolve(true);
                }
            };
        });
    }
    idleTimer() {
        // evita timer multipli
        this.idleReset();
        const min = 5000;
        const max = 20000;
        const loop = () => {
            const delayMs = Phaser.Math.Between(min, max);
            this.delayedAnim = scene.time.delayedCall(delayMs, () => {
                if (gameLogicVariableManager.getCurrentGameMode() === ResourcesDispatcher.GAME_CONSTANTS.GAME_MODE.BASEGAME &&
                    gameLogicVariableManager.getFutureGameMode() === ResourcesDispatcher.GAME_CONSTANTS.GAME_MODE.BASEGAME) {
                    //fa partire animazione idle2 una volta e poi idle in loop
                    this.rightSideGridAnimation.animationState.setAnimation(0, "idle2", false);
                    this.rightSideGridAnimation.animationState.addAnimation(0, "idle", true);
                }
                loop();
            });
        };
        loop();
    }
    idleReset() {
        if (this.delayedAnim && !this.delayedAnim.hasDispatched) {
            this.delayedAnim.remove(false);
        }
        this.delayedAnim = undefined;
    }
    //ENTER LINK
    enterLinkSpin() {
        // disattiva eventuali timer di idle per evitare sovrapposizioni
        this.idleReset();
        // ferma qualunque animazione in corso
        this.rightSideGridAnimation.animationState.setEmptyAnimations(0);
        this.rightSideGridAnimation.animationState.setAnimation(0, "link_enter", false);
        this.rightSideGridAnimation.animationState.addAnimation(0, "link_loop", true);
    }
    //EXIT LINK
    exitLinkSpin() {
        this.rightSideGridAnimation.animationState.setAnimation(0, "link_exit", false);
        this.rightSideGridAnimation.animationState.addAnimation(0, "idle", true);
        this.idleTimer();
    }
    //ENTER FREESPIN
    enterFreeSpin() {
        // disattiva eventuali timer di idle per evitare sovrapposizioni
        this.idleReset();
        // ferma qualunque animazione in corso
        this.rightSideGridAnimation.animationState.setEmptyAnimations(0);
        this.rightSideGridAnimation.animationState.addAnimation(0, "freespin_loop", true);
    }
    //EXIT FREESPIN
    exitFreeSpin() {
        this.rightSideGridAnimation.animationState.setAnimation(0, "freespin_exit", false);
        this.rightSideGridAnimation.animationState.addAnimation(0, "idle", true);
        this.idleTimer();
    }
    //CELEBRATE WIN
    win() {
        // disattiva eventuali timer di idle per evitare sovrapposizioni
        this.idleReset();
        // ferma qualunque animazione in corso
        this.rightSideGridAnimation.animationState.setEmptyAnimations(0);
        soundManager.play(ResourcesDispatcher.SOUNDS.rightSideGridAudio[this.randomInt(0, ResourcesDispatcher.SOUNDS.rightSideGridAudio.length - 1)]);
        this.rightSideGridAnimation.animationState.setAnimation(0, "win", false);
        this.rightSideGridAnimation.animationState.addAnimation(0, "idle", true);
        this.idleTimer();
    }
    getRightSideGridAnimation() {
        return this.rightSideGridAnimation;
    }
    //ANIMATION SHOOT
    shoot() {
        return new Promise((resolve) => {
            // stoppa idle timer e qualsiasi animazione in corso
            this.idleReset();
            this.rightSideGridAnimation.animationState.clearTracks();
            this.rightSideGridAnimation.animationState.setEmptyAnimations(0);
            // imposta lo shoot una volta
            soundManager.play(ResourcesDispatcher.SOUNDS.PISTOL_SHOT);
            const entry = this.rightSideGridAnimation.animationState.setAnimation(0, "link_shoot2", false);
            // listener legato al TrackEntry (non globale)
            entry.listener = {
                complete: () => {
                    entry.listener = null; // pulizia
                    resolve(true);
                },
                end: () => {
                    // viene chiamato sia a fine naturale sia se la traccia viene sostituita
                    entry.listener = null;
                    resolve(true);
                },
                interrupt: () => {
                    // in molte pipeline preferisco comunque risolvere per non lasciare Promise pendenti
                    entry.listener = null;
                    resolve(true);
                }
            };
        });
    }
    resetShoot() {
        this.rightSideGridAnimation.animationState.setAnimation(0, "link_loop", true);
    }
    randomInt(min, max) {
        return Math.floor(Math.random() * (max - min + 1)) + min;
    }
}
